import CandidateListPage from './list'
export default CandidateListPage
